module.exports = __webpack_public_path__ + "img/b6.cf413582.jpg";